module.exports = __webpack_public_path__ + "static/img/live_banner11.19b9aa1.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/solution/live_banner11.png
// module id = KFLI
// module chunks = 1